// ErrorZone — inline zone-failure banner (P1-E10-1 / AC-STATE-1).
//
// Drop-in replacement for a single card/zone's content when that zone's fetch
// fails. Unlike the full-page <ErrorState/>, this banner is sized to sit
// INSIDE a card or bento cell so one failed fetch never blanks the whole page:
// the failed zone banners, every healthy zone keeps rendering.
//
// Import directly by path (not via components/index.js) to keep this additive:
//   import { ErrorZone } from '../../components/primitives/ErrorZone.jsx';
import './errorZone.redesign.css';

export function ErrorZone({ title, error, onRetry, children }) {
  const message = error?.message || 'Unknown error';
  return (
    <div className="error-zone" role="alert" data-testid="error-zone">
      <div className="error-zone__icon" aria-hidden="true">
        ⚠
      </div>
      <div className="error-zone__body">
        <strong className="error-zone__title">
          Couldn&apos;t load {title || 'this zone'} — {message}
        </strong>
        {children ? <div className="error-zone__detail">{children}</div> : null}
      </div>
      {onRetry ? (
        <button type="button" className="btn ghost sm error-zone__retry" onClick={onRetry}>
          Retry
        </button>
      ) : null}
    </div>
  );
}
